import { __awaiter } from "tslib";
import { useNavigate, useParams } from "react-router-dom";
import { getSchedules } from "../../shared/models/api";
import { Shiptypes } from "../../shared/models/model";
import React, { useEffect, useState } from "react";
import { Filter } from "./schedules.form.filter.r";
import { List } from "./schedules.list.r";
export const Schedules = () => {
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [filtered, setFiltered] = useState(null);
    const [schedules, setSchedules] = useState(null);
    const { type } = useParams();
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                if (type === "fluss") {
                    const river = getSchedules("Fluss");
                    setSchedules([...(yield river)]);
                    setFiltered([...(yield river)]);
                }
                else if (type === "see") {
                    const sea = getSchedules("See");
                    setSchedules([...(yield sea)]);
                    setFiltered([...(yield sea)]);
                }
                else {
                    navigate("/");
                }
            }
            catch (e) {
                setError(e);
            }
        }))();
    }, [type]);
    return (React.createElement("section", { className: "visitor-form" },
        React.createElement("h3", { className: "pt0" },
            "Terminauswahl f\u00FCr ",
            Shiptypes[type]),
        React.createElement(Filter, { schedules: schedules, setFiltered: setFiltered }),
        error ? (React.createElement("article", { className: "mv4 mb2" },
            React.createElement("div", { className: "alert alert--danger alert--icon" },
                React.createElement("i", { className: "fas fa-exclamation-triangle" }),
                "Bei der Abfrage einiger Daten ist leider ein Fehler aufgetreten. Bitte probieren Sie es sp\u00E4ter noch einmal."))) : (React.createElement(List, { schedules: filtered }))));
};
export default Schedules;
